import { Box, Button, Card, Container, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { clientConfig, SetS3Config } from "../../../awsClientConfig";
import { TaskRiskReport } from "../reports/type";
import { userProfileData } from "../../../Common/profileInfo";
import { Auth, Storage } from "aws-amplify";
import { GetTaxRiskReports } from "../../../queries/GetTaxRiskReports";
import { GetProfile } from "../../../queries/getProfile";
import { GetPartnerWithoutTaxProfessional } from "../../../queries/GetPartnerWithoutTaxProfessional";
import { fetchQuery, formatPhone } from "../../../functions/misc";
import { GetOrganization } from "../../../queries/GetOrganization";
import { GetPhoneNumbers } from "../../../queries/GetPhoneNumbers";
import moment from "moment";
import { getTaxRiskReport } from "../../../queries/getTaxRiskReport";
import { GetProtectionPlanEligibility } from "../../../queries/GetProtectionPlanEligibility";
import { LastFreeRiskReports } from "../../DashBoards/types";
import useEnrollmentStore from "../../../store/EnrollmentStore";
import { RouterLink } from "../../core/link";
import { ReactComponent as PlayCircleIcon } from '../../../assets/play-circle.svg';
import { Modal } from "react-bootstrap";
import { FaRegWindowClose } from "@react-icons/all-files/fa/FaRegWindowClose";
import { ReactComponent as QuestionIcon } from "../../../assets/TaxShieldReportsIcons/question-circle.svg";
import { useNavigate } from "react-router-dom";
import { GetLatestFormsByProfile } from "../../../queries/GetLatestFormsByProfile";
import { ProfileCafStatus } from "../../../API";
import { CustomerRoleName, useRoleStore } from "../../../store/ProfileStore";
import Footer from "../../footer";

const Overview = () => {
  const client = new clientConfig();

  const [currentTaxSheildReportId, setCurrentTaxShieldReportId] =
    useState<string>("");
  const [taxShieldReport, setTaxShieldReport] = useState<TaskRiskReport>();
  const [clientName, setClientName] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isOrgnaicClient, setisOrgnaicClient] = useState(false);
  const [isReferralClient, setIsReferralClient] = useState(false);
  const [reportDate, setReportDate] = useState({
    Date: "",
    index: 0,
  });
  const [enrollmentRiskReport, setEnrollmentRiskReport] =
    useState<LastFreeRiskReports>();
  const [irsForm, setIRSForm] = useState("");
  const [selectedForm, setSelectedForm] = useState<any>({
    S3Bucket: "",
    S3Key: ""
  });
  const { protectionPlanEnrollment, taxPrepEnrollment } = useEnrollmentStore();
  const [cafStatus, setCafStatus] = useState<ProfileCafStatus>();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const { customerRole } = useRoleStore();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const fetchGetTaxReports = async () => {
    setIsLoading(true);
    await Auth.currentAuthenticatedUser({ bypassCache: true });

    const profileId = await userProfileData();

    await client
      .query({
        query: GetTaxRiskReports,
        variables: { ProfileId: profileId },
      })
      .then(async (res: any) => {
        if (res.data.GetTaxRiskReports !== null) {
          const taxReports: any = res.data.GetTaxRiskReports?.TaxRiskReports;
          const taxRiskReportId = taxReports[0]?.Id;
          setCurrentTaxShieldReportId(taxRiskReportId as string);
          const formatDate = dateformat(taxReports[0]?.ReportDate);
          setReportDate({ Date: formatDate, index: 0 });
        }
      })
      .catch((error) => {
        console.log("error:", error);
      })
      .finally(() => setIsLoading(false));
  };

  const fetchClientName = async () => {
    setIsLoading(true);
    const profileId = await userProfileData();
    const client = new clientConfig();
    client
      .query({
        query: GetProfile,
        variables: { profileId: profileId },
      })
      .then((res: any) => {
        if (res.data.GetProfile !== null) {
          const firstName = res.data.GetProfile?.FirstName;
          const middleName = res.data.GetProfile?.MiddleName
            ? res.data.GetProfile?.MiddleName
            : "";
          const lastName = res.data.GetProfile?.LastName;
          setClientName(firstName + " " + middleName + " " + lastName);
          if (res.data.GetProfile.CafStatus) {
            setCafStatus(res.data.GetProfile.CafStatus);
          }

          if ((res.data.GetProfile.EnrollmentSource === 'Referral' && customerRole === CustomerRoleName.NonTaxPrepReferredCustomer) 
                    || res.data.GetProfile.EnrollmentSource === "Organic") {
            setIsLoading(true);
            setisOrgnaicClient(true);
            client
              .query({
                query: GetPhoneNumbers,
              })
              .then((data: any) => {
                setPhoneNumber(
                  formatPhone(data?.data?.GetPhoneNumbers?.ProfileContactUs)
                );
                setPartnerName("Customer Service");
              });
          } else if (res.data.GetProfile.EnrollmentSource === "Referral") {
            setIsLoading(true);
            setIsReferralClient(true);
            client
              .query({
                query: GetPartnerWithoutTaxProfessional,
                variables: {
                  PartnerId: res.data.GetProfile.PartnerId,
                },
              })
              .then((res: any) => {
                const organizationId = res.data.GetPartner.OrganizationId;

                if (organizationId) {
                  client
                    .query({
                      query: GetOrganization,
                      variables: { organizationId },
                    })
                    .then((res: any) => {
                      setPhoneNumber(
                        formatPhone(res.data.GetOrganization.Phone)
                      );
                      setPartnerName(res.data.GetOrganization.Name);
                    })
                    .catch(() => {});
                }
              });
          }
        }
      })
      .catch((error: any) => {
        console.log(error, "error");
      })
      .finally(() => setIsLoading(false));
  };

  const fetchSingleTaxReport = async (taxRiskReportId: string) => {
    setIsLoading(true);
    await client
      .query({
        query: getTaxRiskReport,
        variables: {
          taxRiskReportId: taxRiskReportId,
        },
      })
      .then((res: any) => {
        setTaxShieldReport(res.data.GetTaxRiskReport);
      })
      .catch((error: any) => {
        if (error.data.GetTaxRiskReport) {
          error.data.GetTaxRiskReport.TaxLiabilitiesByYear =
            error.data.GetTaxRiskReport?.TaxLiabilitiesByYear?.filter(
              (entry: any) => entry !== null
            );
          setTaxShieldReport(error.data.GetTaxRiskReport);
        }
        console.log(error);
      })
      .finally();
  };

  const fetchServiceStatus = async () => {
    const profileId = await userProfileData();

    client
      .query({
        query: GetProtectionPlanEligibility,
        variables: { ProfileId: profileId },
      })
      .then((res: any) => {
        if (res.data.GetProtectionPlanEligibility !== null) {
          setEnrollmentRiskReport(
            res.data.GetProtectionPlanEligibility?.LastTaxRiskReport
          );
        }
      })
      .catch((error: any) => {
        console.log("error:", error);
      });
  };

  const fetchForm8821 = async () => {
    setIsLoading(true);
    await Auth.currentAuthenticatedUser({ bypassCache: true });
    const profileId = await userProfileData();

    const getLatestFormsByProfile = await fetchQuery(
      { ProfileId: profileId },
      GetLatestFormsByProfile
    );
    const form8821 = getLatestFormsByProfile.find(
      (form: any) => form.Name === "Form8821"
    );

    if (form8821) {
      setSelectedForm({
        S3Bucket: form8821.S3Bucket,
        S3Key: form8821.S3Key
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchGetTaxReports();
    fetchClientName();
    fetchServiceStatus();
    fetchForm8821();
  }, []);

  useEffect(() => {
    fetchSingleTaxReport(currentTaxSheildReportId);
  }, [currentTaxSheildReportId]);

  const dateformat = (date: string) => {
    return moment(new Date(date)).utc().format("MMMM DD, YYYY");
  };

  const riskIndicators = taxShieldReport?.RiskIndicators;

  const auditReviewIcon = () =>
    riskIndicators?.AuditReview ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <g id="XCircle">
          <path
            id="Vector"
            d="M12.5 2.25C10.5716 2.25 8.68657 2.82183 7.08319 3.89317C5.47982 4.96451 4.23013 6.48726 3.49218 8.26884C2.75422 10.0504 2.56114 12.0108 2.93735 13.9021C3.31355 15.7934 4.24215 17.5307 5.60571 18.8943C6.96928 20.2579 8.70656 21.1865 10.5979 21.5627C12.4892 21.9389 14.4496 21.7458 16.2312 21.0078C18.0127 20.2699 19.5355 19.0202 20.6068 17.4168C21.6782 15.8134 22.25 13.9284 22.25 12C22.2473 9.41498 21.2192 6.93661 19.3913 5.10872C17.5634 3.28084 15.085 2.25273 12.5 2.25ZM16.0306 14.4694C16.1003 14.5391 16.1556 14.6218 16.1933 14.7128C16.231 14.8039 16.2504 14.9015 16.2504 15C16.2504 15.0985 16.231 15.1961 16.1933 15.2872C16.1556 15.3782 16.1003 15.4609 16.0306 15.5306C15.9609 15.6003 15.8782 15.6556 15.7872 15.6933C15.6961 15.731 15.5986 15.7504 15.5 15.7504C15.4015 15.7504 15.3039 15.731 15.2128 15.6933C15.1218 15.6556 15.0391 15.6003 14.9694 15.5306L12.5 13.0603L10.0306 15.5306C9.96095 15.6003 9.87822 15.6556 9.78718 15.6933C9.69613 15.731 9.59855 15.7504 9.5 15.7504C9.40146 15.7504 9.30388 15.731 9.21283 15.6933C9.12179 15.6556 9.03906 15.6003 8.96938 15.5306C8.8997 15.4609 8.84442 15.3782 8.80671 15.2872C8.769 15.1961 8.74959 15.0985 8.74959 15C8.74959 14.9015 8.769 14.8039 8.80671 14.7128C8.84442 14.6218 8.8997 14.5391 8.96938 14.4694L11.4397 12L8.96938 9.53063C8.82865 9.38989 8.74959 9.19902 8.74959 9C8.74959 8.80098 8.82865 8.61011 8.96938 8.46937C9.11011 8.32864 9.30098 8.24958 9.5 8.24958C9.69903 8.24958 9.8899 8.32864 10.0306 8.46937L12.5 10.9397L14.9694 8.46937C15.0391 8.39969 15.1218 8.34442 15.2128 8.3067C15.3039 8.26899 15.4015 8.24958 15.5 8.24958C15.5986 8.24958 15.6961 8.26899 15.7872 8.3067C15.8782 8.34442 15.9609 8.39969 16.0306 8.46937C16.1003 8.53906 16.1556 8.62178 16.1933 8.71283C16.231 8.80387 16.2504 8.90145 16.2504 9C16.2504 9.09855 16.231 9.19613 16.1933 9.28717C16.1556 9.37822 16.1003 9.46094 16.0306 9.53063L13.5603 12L16.0306 14.4694Z"
            fill="#FB5E56"
          />
        </g>
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <g id="CheckCircle">
          <path
            id="Vector"
            d="M16.7806 9.21937C16.8504 9.28903 16.9057 9.37175 16.9434 9.46279C16.9812 9.55384 17.0006 9.65144 17.0006 9.75C17.0006 9.84856 16.9812 9.94616 16.9434 10.0372C16.9057 10.1283 16.8504 10.211 16.7806 10.2806L11.5306 15.5306C11.461 15.6004 11.3783 15.6557 11.2872 15.6934C11.1962 15.7312 11.0986 15.7506 11 15.7506C10.9014 15.7506 10.8038 15.7312 10.7128 15.6934C10.6218 15.6557 10.539 15.6004 10.4694 15.5306L8.21938 13.2806C8.07865 13.1399 7.99959 12.949 7.99959 12.75C7.99959 12.551 8.07865 12.3601 8.21938 12.2194C8.36011 12.0786 8.55098 11.9996 8.75 11.9996C8.94903 11.9996 9.1399 12.0786 9.28063 12.2194L11 13.9397L15.7194 9.21937C15.789 9.14964 15.8718 9.09432 15.9628 9.05658C16.0538 9.01884 16.1514 8.99941 16.25 8.99941C16.3486 8.99941 16.4462 9.01884 16.5372 9.05658C16.6283 9.09432 16.711 9.14964 16.7806 9.21937ZM22.25 12C22.25 13.9284 21.6782 15.8134 20.6068 17.4168C19.5355 19.0202 18.0127 20.2699 16.2312 21.0078C14.4496 21.7458 12.4892 21.9389 10.5979 21.5627C8.70656 21.1865 6.96928 20.2579 5.60571 18.8943C4.24215 17.5307 3.31355 15.7934 2.93735 13.9021C2.56114 12.0108 2.75422 10.0504 3.49218 8.26884C4.23013 6.48726 5.47982 4.96451 7.08319 3.89317C8.68657 2.82183 10.5716 2.25 12.5 2.25C15.085 2.25273 17.5634 3.28084 19.3913 5.10872C21.2192 6.93661 22.2473 9.41498 22.25 12ZM20.75 12C20.75 10.3683 20.2661 8.77325 19.3596 7.41655C18.4531 6.05984 17.1646 5.00242 15.6571 4.37799C14.1497 3.75357 12.4909 3.59019 10.8905 3.90852C9.29017 4.22685 7.82016 5.01259 6.66637 6.16637C5.51259 7.32015 4.72685 8.79016 4.40853 10.3905C4.0902 11.9908 4.25358 13.6496 4.878 15.1571C5.50242 16.6646 6.55984 17.9531 7.91655 18.8596C9.27326 19.7661 10.8683 20.25 12.5 20.25C14.6873 20.2475 16.7843 19.3775 18.3309 17.8309C19.8775 16.2843 20.7475 14.1873 20.75 12Z"
            fill="#15B79F"
          />
        </g>
      </svg>
    );
  const collectionActivityIcon = () =>
    riskIndicators?.CollectionActivity ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <g id="XCircle">
          <path
            id="Vector"
            d="M12.5 2.25C10.5716 2.25 8.68657 2.82183 7.08319 3.89317C5.47982 4.96451 4.23013 6.48726 3.49218 8.26884C2.75422 10.0504 2.56114 12.0108 2.93735 13.9021C3.31355 15.7934 4.24215 17.5307 5.60571 18.8943C6.96928 20.2579 8.70656 21.1865 10.5979 21.5627C12.4892 21.9389 14.4496 21.7458 16.2312 21.0078C18.0127 20.2699 19.5355 19.0202 20.6068 17.4168C21.6782 15.8134 22.25 13.9284 22.25 12C22.2473 9.41498 21.2192 6.93661 19.3913 5.10872C17.5634 3.28084 15.085 2.25273 12.5 2.25ZM16.0306 14.4694C16.1003 14.5391 16.1556 14.6218 16.1933 14.7128C16.231 14.8039 16.2504 14.9015 16.2504 15C16.2504 15.0985 16.231 15.1961 16.1933 15.2872C16.1556 15.3782 16.1003 15.4609 16.0306 15.5306C15.9609 15.6003 15.8782 15.6556 15.7872 15.6933C15.6961 15.731 15.5986 15.7504 15.5 15.7504C15.4015 15.7504 15.3039 15.731 15.2128 15.6933C15.1218 15.6556 15.0391 15.6003 14.9694 15.5306L12.5 13.0603L10.0306 15.5306C9.96095 15.6003 9.87822 15.6556 9.78718 15.6933C9.69613 15.731 9.59855 15.7504 9.5 15.7504C9.40146 15.7504 9.30388 15.731 9.21283 15.6933C9.12179 15.6556 9.03906 15.6003 8.96938 15.5306C8.8997 15.4609 8.84442 15.3782 8.80671 15.2872C8.769 15.1961 8.74959 15.0985 8.74959 15C8.74959 14.9015 8.769 14.8039 8.80671 14.7128C8.84442 14.6218 8.8997 14.5391 8.96938 14.4694L11.4397 12L8.96938 9.53063C8.82865 9.38989 8.74959 9.19902 8.74959 9C8.74959 8.80098 8.82865 8.61011 8.96938 8.46937C9.11011 8.32864 9.30098 8.24958 9.5 8.24958C9.69903 8.24958 9.8899 8.32864 10.0306 8.46937L12.5 10.9397L14.9694 8.46937C15.0391 8.39969 15.1218 8.34442 15.2128 8.3067C15.3039 8.26899 15.4015 8.24958 15.5 8.24958C15.5986 8.24958 15.6961 8.26899 15.7872 8.3067C15.8782 8.34442 15.9609 8.39969 16.0306 8.46937C16.1003 8.53906 16.1556 8.62178 16.1933 8.71283C16.231 8.80387 16.2504 8.90145 16.2504 9C16.2504 9.09855 16.231 9.19613 16.1933 9.28717C16.1556 9.37822 16.1003 9.46094 16.0306 9.53063L13.5603 12L16.0306 14.4694Z"
            fill="#FB5E56"
          />
        </g>
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <g id="CheckCircle">
          <path
            id="Vector"
            d="M16.7806 9.21937C16.8504 9.28903 16.9057 9.37175 16.9434 9.46279C16.9812 9.55384 17.0006 9.65144 17.0006 9.75C17.0006 9.84856 16.9812 9.94616 16.9434 10.0372C16.9057 10.1283 16.8504 10.211 16.7806 10.2806L11.5306 15.5306C11.461 15.6004 11.3783 15.6557 11.2872 15.6934C11.1962 15.7312 11.0986 15.7506 11 15.7506C10.9014 15.7506 10.8038 15.7312 10.7128 15.6934C10.6218 15.6557 10.539 15.6004 10.4694 15.5306L8.21938 13.2806C8.07865 13.1399 7.99959 12.949 7.99959 12.75C7.99959 12.551 8.07865 12.3601 8.21938 12.2194C8.36011 12.0786 8.55098 11.9996 8.75 11.9996C8.94903 11.9996 9.1399 12.0786 9.28063 12.2194L11 13.9397L15.7194 9.21937C15.789 9.14964 15.8718 9.09432 15.9628 9.05658C16.0538 9.01884 16.1514 8.99941 16.25 8.99941C16.3486 8.99941 16.4462 9.01884 16.5372 9.05658C16.6283 9.09432 16.711 9.14964 16.7806 9.21937ZM22.25 12C22.25 13.9284 21.6782 15.8134 20.6068 17.4168C19.5355 19.0202 18.0127 20.2699 16.2312 21.0078C14.4496 21.7458 12.4892 21.9389 10.5979 21.5627C8.70656 21.1865 6.96928 20.2579 5.60571 18.8943C4.24215 17.5307 3.31355 15.7934 2.93735 13.9021C2.56114 12.0108 2.75422 10.0504 3.49218 8.26884C4.23013 6.48726 5.47982 4.96451 7.08319 3.89317C8.68657 2.82183 10.5716 2.25 12.5 2.25C15.085 2.25273 17.5634 3.28084 19.3913 5.10872C21.2192 6.93661 22.2473 9.41498 22.25 12ZM20.75 12C20.75 10.3683 20.2661 8.77325 19.3596 7.41655C18.4531 6.05984 17.1646 5.00242 15.6571 4.37799C14.1497 3.75357 12.4909 3.59019 10.8905 3.90852C9.29017 4.22685 7.82016 5.01259 6.66637 6.16637C5.51259 7.32015 4.72685 8.79016 4.40853 10.3905C4.0902 11.9908 4.25358 13.6496 4.878 15.1571C5.50242 16.6646 6.55984 17.9531 7.91655 18.8596C9.27326 19.7661 10.8683 20.25 12.5 20.25C14.6873 20.2475 16.7843 19.3775 18.3309 17.8309C19.8775 16.2843 20.7475 14.1873 20.75 12Z"
            fill="#15B79F"
          />
        </g>
      </svg>
    );
  const noticeUpdateIcon = () =>
    riskIndicators?.NoticeUpdate ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <g id="XCircle">
          <path
            id="Vector"
            d="M12.5 2.25C10.5716 2.25 8.68657 2.82183 7.08319 3.89317C5.47982 4.96451 4.23013 6.48726 3.49218 8.26884C2.75422 10.0504 2.56114 12.0108 2.93735 13.9021C3.31355 15.7934 4.24215 17.5307 5.60571 18.8943C6.96928 20.2579 8.70656 21.1865 10.5979 21.5627C12.4892 21.9389 14.4496 21.7458 16.2312 21.0078C18.0127 20.2699 19.5355 19.0202 20.6068 17.4168C21.6782 15.8134 22.25 13.9284 22.25 12C22.2473 9.41498 21.2192 6.93661 19.3913 5.10872C17.5634 3.28084 15.085 2.25273 12.5 2.25ZM16.0306 14.4694C16.1003 14.5391 16.1556 14.6218 16.1933 14.7128C16.231 14.8039 16.2504 14.9015 16.2504 15C16.2504 15.0985 16.231 15.1961 16.1933 15.2872C16.1556 15.3782 16.1003 15.4609 16.0306 15.5306C15.9609 15.6003 15.8782 15.6556 15.7872 15.6933C15.6961 15.731 15.5986 15.7504 15.5 15.7504C15.4015 15.7504 15.3039 15.731 15.2128 15.6933C15.1218 15.6556 15.0391 15.6003 14.9694 15.5306L12.5 13.0603L10.0306 15.5306C9.96095 15.6003 9.87822 15.6556 9.78718 15.6933C9.69613 15.731 9.59855 15.7504 9.5 15.7504C9.40146 15.7504 9.30388 15.731 9.21283 15.6933C9.12179 15.6556 9.03906 15.6003 8.96938 15.5306C8.8997 15.4609 8.84442 15.3782 8.80671 15.2872C8.769 15.1961 8.74959 15.0985 8.74959 15C8.74959 14.9015 8.769 14.8039 8.80671 14.7128C8.84442 14.6218 8.8997 14.5391 8.96938 14.4694L11.4397 12L8.96938 9.53063C8.82865 9.38989 8.74959 9.19902 8.74959 9C8.74959 8.80098 8.82865 8.61011 8.96938 8.46937C9.11011 8.32864 9.30098 8.24958 9.5 8.24958C9.69903 8.24958 9.8899 8.32864 10.0306 8.46937L12.5 10.9397L14.9694 8.46937C15.0391 8.39969 15.1218 8.34442 15.2128 8.3067C15.3039 8.26899 15.4015 8.24958 15.5 8.24958C15.5986 8.24958 15.6961 8.26899 15.7872 8.3067C15.8782 8.34442 15.9609 8.39969 16.0306 8.46937C16.1003 8.53906 16.1556 8.62178 16.1933 8.71283C16.231 8.80387 16.2504 8.90145 16.2504 9C16.2504 9.09855 16.231 9.19613 16.1933 9.28717C16.1556 9.37822 16.1003 9.46094 16.0306 9.53063L13.5603 12L16.0306 14.4694Z"
            fill="#FB5E56"
          />
        </g>
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <g id="CheckCircle">
          <path
            id="Vector"
            d="M16.7806 9.21937C16.8504 9.28903 16.9057 9.37175 16.9434 9.46279C16.9812 9.55384 17.0006 9.65144 17.0006 9.75C17.0006 9.84856 16.9812 9.94616 16.9434 10.0372C16.9057 10.1283 16.8504 10.211 16.7806 10.2806L11.5306 15.5306C11.461 15.6004 11.3783 15.6557 11.2872 15.6934C11.1962 15.7312 11.0986 15.7506 11 15.7506C10.9014 15.7506 10.8038 15.7312 10.7128 15.6934C10.6218 15.6557 10.539 15.6004 10.4694 15.5306L8.21938 13.2806C8.07865 13.1399 7.99959 12.949 7.99959 12.75C7.99959 12.551 8.07865 12.3601 8.21938 12.2194C8.36011 12.0786 8.55098 11.9996 8.75 11.9996C8.94903 11.9996 9.1399 12.0786 9.28063 12.2194L11 13.9397L15.7194 9.21937C15.789 9.14964 15.8718 9.09432 15.9628 9.05658C16.0538 9.01884 16.1514 8.99941 16.25 8.99941C16.3486 8.99941 16.4462 9.01884 16.5372 9.05658C16.6283 9.09432 16.711 9.14964 16.7806 9.21937ZM22.25 12C22.25 13.9284 21.6782 15.8134 20.6068 17.4168C19.5355 19.0202 18.0127 20.2699 16.2312 21.0078C14.4496 21.7458 12.4892 21.9389 10.5979 21.5627C8.70656 21.1865 6.96928 20.2579 5.60571 18.8943C4.24215 17.5307 3.31355 15.7934 2.93735 13.9021C2.56114 12.0108 2.75422 10.0504 3.49218 8.26884C4.23013 6.48726 5.47982 4.96451 7.08319 3.89317C8.68657 2.82183 10.5716 2.25 12.5 2.25C15.085 2.25273 17.5634 3.28084 19.3913 5.10872C21.2192 6.93661 22.2473 9.41498 22.25 12ZM20.75 12C20.75 10.3683 20.2661 8.77325 19.3596 7.41655C18.4531 6.05984 17.1646 5.00242 15.6571 4.37799C14.1497 3.75357 12.4909 3.59019 10.8905 3.90852C9.29017 4.22685 7.82016 5.01259 6.66637 6.16637C5.51259 7.32015 4.72685 8.79016 4.40853 10.3905C4.0902 11.9908 4.25358 13.6496 4.878 15.1571C5.50242 16.6646 6.55984 17.9531 7.91655 18.8596C9.27326 19.7661 10.8683 20.25 12.5 20.25C14.6873 20.2475 16.7843 19.3775 18.3309 17.8309C19.8775 16.2843 20.7475 14.1873 20.75 12Z"
            fill="#15B79F"
          />
        </g>
      </svg>
    );
  const federalComplianceIcon = () =>
    riskIndicators?.FederalCompliance ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <g id="XCircle">
          <path
            id="Vector"
            d="M12.5 2.25C10.5716 2.25 8.68657 2.82183 7.08319 3.89317C5.47982 4.96451 4.23013 6.48726 3.49218 8.26884C2.75422 10.0504 2.56114 12.0108 2.93735 13.9021C3.31355 15.7934 4.24215 17.5307 5.60571 18.8943C6.96928 20.2579 8.70656 21.1865 10.5979 21.5627C12.4892 21.9389 14.4496 21.7458 16.2312 21.0078C18.0127 20.2699 19.5355 19.0202 20.6068 17.4168C21.6782 15.8134 22.25 13.9284 22.25 12C22.2473 9.41498 21.2192 6.93661 19.3913 5.10872C17.5634 3.28084 15.085 2.25273 12.5 2.25ZM16.0306 14.4694C16.1003 14.5391 16.1556 14.6218 16.1933 14.7128C16.231 14.8039 16.2504 14.9015 16.2504 15C16.2504 15.0985 16.231 15.1961 16.1933 15.2872C16.1556 15.3782 16.1003 15.4609 16.0306 15.5306C15.9609 15.6003 15.8782 15.6556 15.7872 15.6933C15.6961 15.731 15.5986 15.7504 15.5 15.7504C15.4015 15.7504 15.3039 15.731 15.2128 15.6933C15.1218 15.6556 15.0391 15.6003 14.9694 15.5306L12.5 13.0603L10.0306 15.5306C9.96095 15.6003 9.87822 15.6556 9.78718 15.6933C9.69613 15.731 9.59855 15.7504 9.5 15.7504C9.40146 15.7504 9.30388 15.731 9.21283 15.6933C9.12179 15.6556 9.03906 15.6003 8.96938 15.5306C8.8997 15.4609 8.84442 15.3782 8.80671 15.2872C8.769 15.1961 8.74959 15.0985 8.74959 15C8.74959 14.9015 8.769 14.8039 8.80671 14.7128C8.84442 14.6218 8.8997 14.5391 8.96938 14.4694L11.4397 12L8.96938 9.53063C8.82865 9.38989 8.74959 9.19902 8.74959 9C8.74959 8.80098 8.82865 8.61011 8.96938 8.46937C9.11011 8.32864 9.30098 8.24958 9.5 8.24958C9.69903 8.24958 9.8899 8.32864 10.0306 8.46937L12.5 10.9397L14.9694 8.46937C15.0391 8.39969 15.1218 8.34442 15.2128 8.3067C15.3039 8.26899 15.4015 8.24958 15.5 8.24958C15.5986 8.24958 15.6961 8.26899 15.7872 8.3067C15.8782 8.34442 15.9609 8.39969 16.0306 8.46937C16.1003 8.53906 16.1556 8.62178 16.1933 8.71283C16.231 8.80387 16.2504 8.90145 16.2504 9C16.2504 9.09855 16.231 9.19613 16.1933 9.28717C16.1556 9.37822 16.1003 9.46094 16.0306 9.53063L13.5603 12L16.0306 14.4694Z"
            fill="#FB5E56"
          />
        </g>
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <g id="CheckCircle">
          <path
            id="Vector"
            d="M16.7806 9.21937C16.8504 9.28903 16.9057 9.37175 16.9434 9.46279C16.9812 9.55384 17.0006 9.65144 17.0006 9.75C17.0006 9.84856 16.9812 9.94616 16.9434 10.0372C16.9057 10.1283 16.8504 10.211 16.7806 10.2806L11.5306 15.5306C11.461 15.6004 11.3783 15.6557 11.2872 15.6934C11.1962 15.7312 11.0986 15.7506 11 15.7506C10.9014 15.7506 10.8038 15.7312 10.7128 15.6934C10.6218 15.6557 10.539 15.6004 10.4694 15.5306L8.21938 13.2806C8.07865 13.1399 7.99959 12.949 7.99959 12.75C7.99959 12.551 8.07865 12.3601 8.21938 12.2194C8.36011 12.0786 8.55098 11.9996 8.75 11.9996C8.94903 11.9996 9.1399 12.0786 9.28063 12.2194L11 13.9397L15.7194 9.21937C15.789 9.14964 15.8718 9.09432 15.9628 9.05658C16.0538 9.01884 16.1514 8.99941 16.25 8.99941C16.3486 8.99941 16.4462 9.01884 16.5372 9.05658C16.6283 9.09432 16.711 9.14964 16.7806 9.21937ZM22.25 12C22.25 13.9284 21.6782 15.8134 20.6068 17.4168C19.5355 19.0202 18.0127 20.2699 16.2312 21.0078C14.4496 21.7458 12.4892 21.9389 10.5979 21.5627C8.70656 21.1865 6.96928 20.2579 5.60571 18.8943C4.24215 17.5307 3.31355 15.7934 2.93735 13.9021C2.56114 12.0108 2.75422 10.0504 3.49218 8.26884C4.23013 6.48726 5.47982 4.96451 7.08319 3.89317C8.68657 2.82183 10.5716 2.25 12.5 2.25C15.085 2.25273 17.5634 3.28084 19.3913 5.10872C21.2192 6.93661 22.2473 9.41498 22.25 12ZM20.75 12C20.75 10.3683 20.2661 8.77325 19.3596 7.41655C18.4531 6.05984 17.1646 5.00242 15.6571 4.37799C14.1497 3.75357 12.4909 3.59019 10.8905 3.90852C9.29017 4.22685 7.82016 5.01259 6.66637 6.16637C5.51259 7.32015 4.72685 8.79016 4.40853 10.3905C4.0902 11.9908 4.25358 13.6496 4.878 15.1571C5.50242 16.6646 6.55984 17.9531 7.91655 18.8596C9.27326 19.7661 10.8683 20.25 12.5 20.25C14.6873 20.2475 16.7843 19.3775 18.3309 17.8309C19.8775 16.2843 20.7475 14.1873 20.75 12Z"
            fill="#15B79F"
          />
        </g>
      </svg>
    );

  const riskIndicatorsArray = [
    {
      label: "AUDIT REVIEW",
      icon: auditReviewIcon(),
    },
    {
      label: "COLLECTION ACTIVITY",
      icon: collectionActivityIcon(),
    },
    {
      label: "NOTICES & UPDATES",
      icon: noticeUpdateIcon(),
    },
    {
      label: "FEDERAL COMPLIANCE",
      icon: federalComplianceIcon(),
    },
  ];

  const downloadForm = async () => {
    try {
      SetS3Config(selectedForm.S3Bucket, "public");
      const Agreement:any = await Storage.get(selectedForm.S3Key, {
        customPrefix: { public: "" },
        download: true,
        level: "public",
        contentType: "application/pdf",
      });
      downloadBlob(Agreement.Body, "Tax Information Authorization Form 8821");
    } catch (error) {
      console.log("error", error);
    }
  };

  function downloadBlob(blob: any, filename: any) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  }

  return (
    <>
    <div className="page-container">
    <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
      <Container
        sx={{ paddingTop: "24px", paddingBottom: "24px", margin: "1rem" }}
      >
        <Box
          display={"flex"}
          gap={2}
          sx={{
            "@media(max-width: 1500px)": { flexDirection: "column-reverse" },
          }}
        >
          <Box>
            <Box
              height={"auto"}
              maxWidth={"1174"}
              sx={{
                borderRadius: "20px",
                border: "1px solid #DCDFE4",
                background: "#FFF",
                padding: "32px",
              }}
            >
              <Box
                display={"flex"}
                justifyContent={"flex-end"}
                alignItems={"flex-end"}
              >
                {reportDate.Date &&
                <Box
                  sx={{
                    borderRadius: "8px",
                    background: "#F0FDFA",
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "4px",
                    alignItems: "center",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10 3.125C8.51664 3.125 7.0666 3.56487 5.83323 4.38898C4.59986 5.21309 3.63856 6.38443 3.07091 7.75487C2.50325 9.12532 2.35472 10.6333 2.64411 12.0882C2.9335 13.543 3.64781 14.8794 4.6967 15.9283C5.7456 16.9772 7.08197 17.6915 8.53683 17.9809C9.99168 18.2703 11.4997 18.1218 12.8701 17.5541C14.2406 16.9864 15.4119 16.0251 16.236 14.7918C17.0601 13.5584 17.5 12.1084 17.5 10.625C17.4977 8.63657 16.7068 6.73024 15.3008 5.32421C13.8948 3.91818 11.9884 3.12727 10 3.125ZM10 16.875C8.76387 16.875 7.5555 16.5084 6.52769 15.8217C5.49988 15.1349 4.6988 14.1588 4.22576 13.0168C3.75271 11.8747 3.62894 10.6181 3.8701 9.40569C4.11125 8.1933 4.70651 7.07966 5.58059 6.20558C6.45466 5.3315 7.56831 4.73625 8.78069 4.49509C9.99307 4.25393 11.2497 4.37771 12.3918 4.85075C13.5338 5.3238 14.5099 6.12488 15.1967 7.15269C15.8834 8.18049 16.25 9.38887 16.25 10.625C16.2481 12.282 15.5891 13.8707 14.4174 15.0424C13.2457 16.2141 11.657 16.8731 10 16.875ZM13.5672 7.05781C13.6253 7.11586 13.6714 7.18479 13.7029 7.26066C13.7343 7.33654 13.7505 7.41787 13.7505 7.5C13.7505 7.58213 13.7343 7.66346 13.7029 7.73934C13.6714 7.81521 13.6253 7.88414 13.5672 7.94219L10.4422 11.0672C10.3841 11.1253 10.3152 11.1713 10.2393 11.2027C10.1634 11.2342 10.0821 11.2503 10 11.2503C9.91788 11.2503 9.83656 11.2342 9.76069 11.2027C9.68482 11.1713 9.61588 11.1253 9.55782 11.0672C9.49975 11.0091 9.45368 10.9402 9.42226 10.8643C9.39083 10.7884 9.37466 10.7071 9.37466 10.625C9.37466 10.5429 9.39083 10.4616 9.42226 10.3857C9.45368 10.3098 9.49975 10.2409 9.55782 10.1828L12.6828 7.05781C12.7409 6.9997 12.8098 6.9536 12.8857 6.92215C12.9615 6.8907 13.0429 6.87451 13.125 6.87451C13.2071 6.87451 13.2885 6.8907 13.3643 6.92215C13.4402 6.9536 13.5091 6.9997 13.5672 7.05781ZM7.5 1.25C7.5 1.08424 7.56585 0.925268 7.68306 0.808058C7.80027 0.690848 7.95924 0.625 8.125 0.625H11.875C12.0408 0.625 12.1997 0.690848 12.3169 0.808058C12.4342 0.925268 12.5 1.08424 12.5 1.25C12.5 1.41576 12.4342 1.57473 12.3169 1.69194C12.1997 1.80915 12.0408 1.875 11.875 1.875H8.125C7.95924 1.875 7.80027 1.80915 7.68306 1.69194C7.56585 1.57473 7.5 1.41576 7.5 1.25Z"
                      fill="#302689"
                    />
                  </svg>
                  <Typography
                    sx={{
                      color: "var(--chip-soft-success-color, #134E48)",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "13px",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "18px",
                      letterSpacing: "0.16px",
                    }}
                  >
                    Report Created: {reportDate.Date}
                  </Typography>
                </Box>
                }
              </Box>
              <br />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  "@media(max-width: 633px)": { flexDirection: "column" },
                }}
              >
                <Typography
                  sx={{
                    color: "#667085",
                    textAlign: "center",
                    fontSize: "42px",
                    fontWeight: 700,
                    "@media (max-width: 256px)": {
                      fontSize: "30px",
                    },
                  }}
                >
                  CURRENT RISK LEVEL:{" "}
                  <span style={{ color: taxShieldReport ? "#F84562" : "#667085" }}>
                    {taxShieldReport?.RiskIndicators?.OverallRisk || "N/A"}
                  </span>
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "#000000",
                    fontFamily: "Inter, sans-serif",
                    fontSize: "24px",
                    fontWeight: 700,
                    textAlign: "center",
                    "@media(max-width: 633px)": { flexDirection: "column" },
                    "@media(max-width: 244px)": { fontSize: "20px" },
                  }}
                >
                  We strongly recommend a consultation to help
                  <br />
                  evaluate your current tax situation and IRS collections risk.
                  <br />
                  <Box mt={2}>
                    {" "}
                    {/* Use Material-UI spacing */}
                    {`Please contact ${isReferralClient?partnerName:'us immediately'} at ${phoneNumber}`}
                    {taxShieldReport?.RiskIndicators?.OverallRisk === "High" &&
                      isOrgnaicClient && (
                        <>
                          {" "}
                          or{" "}
                          <RouterLink href="/schedule-appointment">
                            schedule an appointment
                          </RouterLink>
                        </>
                      )}
                  </Box>
                </Typography>
              </Box>
              <br />
              <br />

              <Box
                padding={"20px"}
                gap={"25.5px"}
                sx={{
                  borderTop: "1px solid #DCDFE4",
                  marginLeft: "-32px",
                  marginRight: "-32px",
                  paddingBottom: "2px",
                }}
              >
                <Box
                  display={"flex"}
                  flexDirection={"row"} // Default to row
                  justifyContent={"space-around"}
                  alignItems={"center"}
                  flexWrap={"nowrap"}
                  sx={{
                    "@media (max-width: 645px)": {
                      flexDirection: "column", // Change to column
                      justifyContent: "space-between",
                      gap: "1rem",
                    },
                  }}
                >
                  {taxShieldReport?.RiskIndicators ? (
                    riskIndicatorsArray.map((item, index) => (
                      <Box display="flex" flexDirection="row" key={index}>
                        {item.icon}
                        <Typography>{item.label}</Typography>
                      </Box>
                    ))
                  ) : (
                    Array(4).fill(null).map((_, index) => (
                      <Box display="flex" flexDirection="row" alignItems="center" key={index}>
                        <QuestionIcon width={40} height={40} className="icon-class" />
                        <Typography sx={{ marginLeft: "16px", fontWeight: 700 }}>-</Typography>
                      </Box>
                    ))
                  )}

                </Box>
              </Box>
            </Box>
            <br></br>

            <Box
              display={"flex"}
              justifyContent={"space-between"}
              gap={2}
              sx={{
                "@media(max-width: 1501px)": {
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                },
                "@media (max-width: 480px)": {
                  width: "calc(100% - 30px)",
                },
              }}
            >

              {cafStatus === ProfileCafStatus.Rejected &&
                <Box>
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"flex-start"}
                    gap={"26px"}
                    sx={{
                      borderRadius: "20px",
                      border: "1px solid #DCDFE4",
                      background: "#FFFF",
                      padding: "32px",
                      paddingBottom: "8px",
                      width: "auto",
                      height: "auto",
                      boxShadow:
                        "0px 0px 0px 1px rgba(0, 0, 0, 0.06), 0px 5px 22px 0px rgba(0, 0, 0, 0.04)",
                    }}
                  >
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      sx={{
                        display: "flex",
                        padding: "6px 12px",
                        alignItems: "center",
                        gap: "8px",
                        borderRadius: "8px",
                        height: "34px",
                        width: "199px",
                        background: "#F84562",
                        boxShadow: "0px 3px 14px 0px rgba(0, 0, 0, 0.08)",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g id="exclamation">
                          <g id="Vector">
                            <path
                              d="M8.75195 13.75C8.75195 13.0596 9.3116 12.5 10.002 12.5C10.6923 12.5 11.252 13.0596 11.252 13.75C11.252 14.4404 10.6923 15 10.002 15C9.3116 15 8.75195 14.4404 8.75195 13.75Z"
                              fill="white"
                            />
                            <path
                              d="M8.87441 6.2438C8.80781 5.57786 9.33076 5 10 5C10.6693 5 11.1922 5.57785 11.1256 6.2438L10.6872 10.6281C10.6519 10.9811 10.3548 11.25 10 11.25C9.64522 11.25 9.34814 10.9811 9.31284 10.6281L8.87441 6.2438Z"
                              fill="white"
                            />
                          </g>
                        </g>
                      </svg>
                      <Typography
                        sx={{
                          color: "#FFF",
                          fontFeatureSettings: "'liga' off, 'clig' off",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "157%", // You can also use '21.98px' if preferred
                        }}
                      >
                        Alert: Action Required
                      </Typography>
                    </Box>

                    <Box
                      display={"flex"}
                      flexDirection={"column"}
                      justifyContent={"space-between"}
                    >
                      <Typography
                        sx={{
                          color: "var(--text-secondary, #667085)",
                          fontFeatureSettings: "'liga' off, 'clig' off",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "400",
                          lineHeight: "157%",
                        }}
                      >
                        We were unable to retrieve your IRS transcript because the
                        Form 8821 authorization we have on file is no longer
                        valid. To continue monitoring your tax-related information
                        and ensuring timely updates, please submit a new Form
                        8821.{" "}
                      </Typography>
                      <br></br>
                      <Typography
                        color={"#667085"}
                        sx={{
                          fontFeatureSettings: "'liga' off, 'clig' off",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "400",
                          lineHeight: "157%",
                        }}
                      >
                        Next Steps:
                      </Typography>
                      <br></br>
                      <Typography
                        sx={{
                          color: "var(--text-secondary, #667085)",
                          fontFeatureSettings: "'liga' off, 'clig' off",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "400",
                          lineHeight: "157%",
                        }}
                      >
                        {`1. Complete a new Form 8821`}
                        <br />
                        {`2. If you download the form, upload the signed form directly to your account`}
                        <br />
                        {`3. Contact our support team if you need assistance with this process.`}
                      </Typography>
                      <br />
                      <Typography
                        sx={{
                          color: "var(--text-secondary, #667085)",
                          fontFeatureSettings: "'liga' off, 'clig' off",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "400",
                          lineHeight: "157%",
                        }}
                      >
                        Thank you for your prompt attention to this matter
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        height: "54px",
                        padding: "9px 16px 8px 16px",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        alignSelf: "flex-start",
                        gap: "227px",
                        borderTop: "1px solid var(--divider, #DCDFE4)",
                        marginLeft: "-32px",
                        width: "calc(100% + 64px)",
                      }}
                    >
                      <Box
                        display={"flex"}
                        justifyContent={"space-between"}
                        padding={"6px"}
                      >
                        <Button
                          sx={{
                            backgroundColor: "rgba(240, 247, 252, 1)",
                            color: "rgba(91, 81, 81, 1)",
                            fontFamily: "Inter",
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "22px",
                            letterSpacing: "0.2px",
                            textWrap: "nowrap",
                          }}
                          onClick={downloadForm}
                        >
                          Download Form 8821
                        </Button>
                        <Button
                          sx={{
                            backgroundColor: "#4C5360",
                            color: "#FFF",
                            fontFamily: "Inter, sans-serif",
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "22px",
                            letterSpacing: "0.2px",
                            textWrap: "nowrap",
                            "&:hover" :{
                              backgroundColor: "#4C5360",
                            }
                          }}
                          onClick={handleShow}
                        >
                          Complete E-Form <PlayCircleIcon />
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              }
              <br />

             {isOrgnaicClient &&  <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"flex-start"}
                gap={"26px"}
                sx={{
                  borderRadius: "20px",
                  border: "1px solid #DCDFE4",
                  background: "#FFFF",
                  padding: "32px 24px",
                  paddingBottom: "0px",
                  width: "auto",
                  height: "auto",
                  boxShadow:
                    "0px 0px 0px 1px rgba(0, 0, 0, 0.06), 0px 5px 22px 0px rgba(0, 0, 0, 0.04)",
                  "@media (max-width: 480px)": {
                    width: "calc(100% - 5px)",
                  },
                }}
              >
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  padding={"6px 12px"}
                  sx={{
                    borderRadius: "8px",
                    background: "#1D89D2",
                    boxShadow: "0px 3px 14px 0px rgba(0, 0, 0, 0.08)",
                    height: "auto",
                    width: "auto",
                    "@media (max-width: 480px)": {
                      width: "calc(100% - 30px)",
                    },
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g id="Briefcase">
                      <path
                        id="Vector"
                        d="M16.875 4.375H13.75V3.75C13.75 3.25272 13.5525 2.77581 13.2008 2.42417C12.8492 2.07254 12.3723 1.875 11.875 1.875H8.125C7.62772 1.875 7.15081 2.07254 6.79917 2.42417C6.44754 2.77581 6.25 3.25272 6.25 3.75V4.375H3.125C2.79348 4.375 2.47554 4.5067 2.24112 4.74112C2.0067 4.97554 1.875 5.29348 1.875 5.625V15.625C1.875 15.9565 2.0067 16.2745 2.24112 16.5089C2.47554 16.7433 2.79348 16.875 3.125 16.875H16.875C17.2065 16.875 17.5245 16.7433 17.7589 16.5089C17.9933 16.2745 18.125 15.9565 18.125 15.625V5.625C18.125 5.29348 17.9933 4.97554 17.7589 4.74112C17.5245 4.5067 17.2065 4.375 16.875 4.375ZM7.5 3.75C7.5 3.58424 7.56585 3.42527 7.68306 3.30806C7.80027 3.19085 7.95924 3.125 8.125 3.125H11.875C12.0408 3.125 12.1997 3.19085 12.3169 3.30806C12.4342 3.42527 12.5 3.58424 12.5 3.75V4.375H7.5V3.75ZM16.875 5.625V8.87578C14.7655 10.024 12.4018 10.6254 10 10.625C7.59828 10.6254 5.23471 10.0243 3.125 8.87656V5.625H16.875ZM16.875 15.625H3.125V10.2844C5.26557 11.3314 7.61708 11.8755 10 11.875C12.383 11.8751 14.7344 11.3307 16.875 10.2836V15.625ZM8.125 8.75C8.125 8.58424 8.19085 8.42527 8.30806 8.30806C8.42527 8.19085 8.58424 8.125 8.75 8.125H11.25C11.4158 8.125 11.5747 8.19085 11.6919 8.30806C11.8092 8.42527 11.875 8.58424 11.875 8.75C11.875 8.91576 11.8092 9.07473 11.6919 9.19194C11.5747 9.30915 11.4158 9.375 11.25 9.375H8.75C8.58424 9.375 8.42527 9.30915 8.30806 9.19194C8.19085 9.07473 8.125 8.91576 8.125 8.75Z"
                        fill="white"
                      />
                    </g>
                  </svg>
                  <Typography
                    sx={{
                      color: "#FFF",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "21.98px", // or '21.98px' if you prefer\
                      whiteSpace: "nowrap",
                      "@media (max-width: 480px)": {
                        width: "calc(100% - 30px)",
                      },
                    }}
                  >
                    Tax Preparation enrollment is valid until April 5, 2025
                  </Typography>
                </Box>
                <Box display={"flex"} gap={0.5}>
                  <Typography
                    sx={{
                      color: "var(--text-primary, #212636)",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "18px",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "120%", // or '21.6px' if preferred
                    }}
                  >
                    Your Subscription Includes
                  </Typography>
                  <Typography
                    sx={{
                      color: "var(--text-primary, #212636)",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "18px",
                      fontStyle: "normal",
                      fontWeight: "700",
                      lineHeight: "120%",
                    }}
                  >
                    2024 Tax Return
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    color: "var(--text-secondary, #667085)",
                    fontFeatureSettings: "'liga' off, 'clig' off",
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "157%", // or '21.98px' if you prefer
                  }}
                >
                  As part of your subscription, you’re automatically entitled to
                  our 2024 tax return preparation service at no additional cost.
                  Our goal is to make tax filing stress-free by ensuring that
                  your return is accurate, compliant, and filed on time.
                </Typography>

                <Typography
                  sx={{
                    color: "var(--text-secondary, #667085)",
                    fontFeatureSettings: "'liga' off, 'clig' off",
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "157%",
                  }}
                >
                  What’s Included:
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    color: "var(--text-secondary, #667085)",
                    fontFeatureSettings: "'liga' off, 'clig' off",
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    lineHeight: "157%",
                  }}
                >
                  <li>
                    Full preparation of your 2024 Federal and State tax returns
                  </li>

                  <Box />
                  <Box
                    sx={{
                      color: "var(--text-secondary, #667085)",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "157%", // or '21.98px' if preferred
                    }}
                  >
                    <li>
                      Review and use of your IRS transcript to identify
                      potential issues
                    </li>
                    <li>
                      Strategic planning to maximize your tax deductions and
                      credits
                    </li>
                  </Box>
                  <Box></Box>
                </Box>
                <Typography
                  sx={{
                    color: "var(--text-secondary, #667085)",
                    fontFeatureSettings: "'liga' off, 'clig' off",
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 700,
                  }}
                >
                  How it Works:
                </Typography>

                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  flexShrink={1}
                  component="ul"
                  sx={{
                    paddingLeft: "20px",
                    // Adjust padding as needed
                  }}
                >
                  <Box
                    component="li"
                    sx={{
                      color: "var(--text-secondary, #667085)",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "157%",
                    }}
                  >
                    <span
                      style={{
                        color: "var(--text-secondary, #667085)",
                        fontWeight: 700,
                      }}
                    >
                      Step 1:
                    </span>{" "}
                    Click on the button “Start My 2024 Tax Return”
                  </Box>
                  <Box
                    component="li"
                    sx={{
                      color: "var(--text-secondary, #667085)",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "157%",
                    }}
                  >
                    <span
                      style={{
                        color: "var(--text-secondary, #667085)",
                        fontWeight: 700,
                      }}
                    >
                      Step 2:
                    </span>{" "}
                    Upload Required documents
                  </Box>
                  <Box
                    component="li"
                    sx={{
                      color: "var(--text-secondary, #667085)",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "157%",
                    }}
                  >
                    <span
                      style={{
                        color: "var(--text-secondary, #667085)",
                        fontWeight: 700,
                      }}
                    >
                      Step 3:
                    </span>{" "}
                    Our team of tax professionals will handle the rest, from
                    preparing your return to submitting it securely to the IRS
                    and state authorities.
                  </Box>
                  <Box
                    component="li"
                    sx={{
                      color: "var(--text-secondary, #667085)",
                      fontFeatureSettings: "'liga' off, 'clig' off",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "157%",
                    }}
                  >
                    <span
                      style={{
                        color: "var(--text-secondary, #667085)",
                        fontWeight: 700,
                      }}
                    >
                      Step 4:
                    </span>{" "}
                    You’ll receive a confirmation once your return has been
                    successfully filed, along with any next steps.
                  </Box>
                  <br />

                  <Box
                    sx={{
                      height: "54px",
                      padding: "9px 16px 8px 16px",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      alignSelf: "flex-start",

                      borderTop: "1px solid var(--divider, #DCDFE4)",
                      marginLeft: "-46px",
                      width: "calc(100% + 70px)",
                    }}
                  >
                    <Box
                      display={"flex"}
                      justifyContent={"space-between"}
                      padding={"8px"}
                    >
                      <Button
                        sx={{
                          backgroundColor: "rgba(240, 247, 252, 1)",
                          color: "#4C5360",
                          fontFamily: "Inter",
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "22px",
                          letterSpacing: "0.2px",
                          textWrap: "nowrap",
                        }}
                      >
                        Skip 2024 Tax Return
                      </Button>
                      <Button
                        sx={{
                          backgroundColor: "#4C5360",
                          color: "#FFF",
                          fontFamily: "Inter, sans-serif",
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "22px",
                          letterSpacing: "0.2px",
                          textWrap: "nowrap",
                        }}
                      >
                        Start my 2024 Tax Return <PlayCircleIcon />
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box> }
            </Box>
          </Box>

          <Box maxWidth={"270px"}>
            <Card>
              <Box
                width={"270px"}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"16px"}
                padding={"32px 24px 16px 24px"}
                sx={{
                  borderRadius: "20px",
                  border: "1px solid #DCDFE4",
                  background: "#FFF",
                  padding: "32px 24px",
                  "@media (max-width: 334px)": {
                    height: "auto",
                    width: "auto",
                  },
                }}
              >
                <Typography
                  sx={{
                    color: "var(--text-primary, #212636)",
                    fontFeatureSettings: "'liga' off, 'clig' off",
                    fontFamily: "Inter, sans-serif",
                    fontSize: "18px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "120%",
                    textWrap: "nowrap", // or '21.6px' if you prefer
                  }}
                >
                  Service Status
                </Typography>

                <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
                  {/* 
                  <Box display={"flex"} gap={"8px"} flexDirection={"row"}>
                    {protectionPlanEnrollment?.enrollmentStatus ===
                      "Completed" &&
                    taxPrepEnrollment?.taxPrepEnrollmentCompleted ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g id="CheckCircle">
                          <path
                            id="Vector"
                            d="M16.2806 9.21937C16.3504 9.28903 16.4057 9.37175 16.4434 9.46279C16.4812 9.55384 16.5006 9.65144 16.5006 9.75C16.5006 9.84856 16.4812 9.94616 16.4434 10.0372C16.4057 10.1283 16.3504 10.211 16.2806 10.2806L11.0306 15.5306C10.961 15.6004 10.8783 15.6557 10.7872 15.6934C10.6962 15.7312 10.5986 15.7506 10.5 15.7506C10.4014 15.7506 10.3038 15.7312 10.2128 15.6934C10.1218 15.6557 10.039 15.6004 9.96938 15.5306L7.71938 13.2806C7.57865 13.1399 7.49959 12.949 7.49959 12.75C7.49959 12.551 7.57865 12.3601 7.71938 12.2194C7.86011 12.0786 8.05098 11.9996 8.25 11.9996C8.44903 11.9996 8.6399 12.0786 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.289 9.14964 15.3718 9.09432 15.4628 9.05658C15.5538 9.01884 15.6514 8.99941 15.75 8.99941C15.8486 8.99941 15.9462 9.01884 16.0372 9.05658C16.1283 9.09432 16.211 9.14964 16.2806 9.21937ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96451 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7661 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6497 3.75357 11.9909 3.59019 10.3905 3.90852C8.79017 4.22685 7.32016 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90853 10.3905C3.5902 11.9908 3.75358 13.6496 4.378 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77326 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z"
                            fill="#15B79F"
                          />
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g id="XCircle">
                          <path
                            id="Vector"
                            d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM15.5306 14.4694C15.6003 14.5391 15.6556 14.6218 15.6933 14.7128C15.731 14.8039 15.7504 14.9015 15.7504 15C15.7504 15.0985 15.731 15.1961 15.6933 15.2872C15.6556 15.3782 15.6003 15.4609 15.5306 15.5306C15.4609 15.6003 15.3782 15.6556 15.2872 15.6933C15.1961 15.731 15.0986 15.7504 15 15.7504C14.9015 15.7504 14.8039 15.731 14.7128 15.6933C14.6218 15.6556 14.5391 15.6003 14.4694 15.5306L12 13.0603L9.53063 15.5306C9.46095 15.6003 9.37822 15.6556 9.28718 15.6933C9.19613 15.731 9.09855 15.7504 9 15.7504C8.90146 15.7504 8.80388 15.731 8.71283 15.6933C8.62179 15.6556 8.53906 15.6003 8.46938 15.5306C8.3997 15.4609 8.34442 15.3782 8.30671 15.2872C8.269 15.1961 8.24959 15.0985 8.24959 15C8.24959 14.9015 8.269 14.8039 8.30671 14.7128C8.34442 14.6218 8.3997 14.5391 8.46938 14.4694L10.9397 12L8.46938 9.53063C8.32865 9.38989 8.24959 9.19902 8.24959 9C8.24959 8.80098 8.32865 8.61011 8.46938 8.46937C8.61011 8.32864 8.80098 8.24958 9 8.24958C9.19903 8.24958 9.3899 8.32864 9.53063 8.46937L12 10.9397L14.4694 8.46937C14.5391 8.39969 14.6218 8.34442 14.7128 8.3067C14.8039 8.26899 14.9015 8.24958 15 8.24958C15.0986 8.24958 15.1961 8.26899 15.2872 8.3067C15.3782 8.34442 15.4609 8.39969 15.5306 8.46937C15.6003 8.53906 15.6556 8.62178 15.6933 8.71283C15.731 8.80387 15.7504 8.90145 15.7504 9C15.7504 9.09855 15.731 9.19613 15.6933 9.28717C15.6556 9.37822 15.6003 9.46094 15.5306 9.53063L13.0603 12L15.5306 14.4694Z"
                            fill="#FB5E56"
                          />
                        </g>
                      </svg>
                    )}

                    <Typography>2023 Tax Return Filed</Typography>
                  </Box>
                  */}
                  <Box display={"flex"} gap={"8px"}>
                    {enrollmentRiskReport?.Status !== "Failed" &&
                    enrollmentRiskReport?.Status !== "Rejected" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g id="CheckCircle">
                          <path
                            id="Vector"
                            d="M16.2806 9.21937C16.3504 9.28903 16.4057 9.37175 16.4434 9.46279C16.4812 9.55384 16.5006 9.65144 16.5006 9.75C16.5006 9.84856 16.4812 9.94616 16.4434 10.0372C16.4057 10.1283 16.3504 10.211 16.2806 10.2806L11.0306 15.5306C10.961 15.6004 10.8783 15.6557 10.7872 15.6934C10.6962 15.7312 10.5986 15.7506 10.5 15.7506C10.4014 15.7506 10.3038 15.7312 10.2128 15.6934C10.1218 15.6557 10.039 15.6004 9.96938 15.5306L7.71938 13.2806C7.57865 13.1399 7.49959 12.949 7.49959 12.75C7.49959 12.551 7.57865 12.3601 7.71938 12.2194C7.86011 12.0786 8.05098 11.9996 8.25 11.9996C8.44903 11.9996 8.6399 12.0786 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.289 9.14964 15.3718 9.09432 15.4628 9.05658C15.5538 9.01884 15.6514 8.99941 15.75 8.99941C15.8486 8.99941 15.9462 9.01884 16.0372 9.05658C16.1283 9.09432 16.211 9.14964 16.2806 9.21937ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96451 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7661 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6497 3.75357 11.9909 3.59019 10.3905 3.90852C8.79017 4.22685 7.32016 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90853 10.3905C3.5902 11.9908 3.75358 13.6496 4.378 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77326 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z"
                            fill="#15B79F"
                          />
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g id="XCircle">
                          <path
                            id="Vector"
                            d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM15.5306 14.4694C15.6003 14.5391 15.6556 14.6218 15.6933 14.7128C15.731 14.8039 15.7504 14.9015 15.7504 15C15.7504 15.0985 15.731 15.1961 15.6933 15.2872C15.6556 15.3782 15.6003 15.4609 15.5306 15.5306C15.4609 15.6003 15.3782 15.6556 15.2872 15.6933C15.1961 15.731 15.0986 15.7504 15 15.7504C14.9015 15.7504 14.8039 15.731 14.7128 15.6933C14.6218 15.6556 14.5391 15.6003 14.4694 15.5306L12 13.0603L9.53063 15.5306C9.46095 15.6003 9.37822 15.6556 9.28718 15.6933C9.19613 15.731 9.09855 15.7504 9 15.7504C8.90146 15.7504 8.80388 15.731 8.71283 15.6933C8.62179 15.6556 8.53906 15.6003 8.46938 15.5306C8.3997 15.4609 8.34442 15.3782 8.30671 15.2872C8.269 15.1961 8.24959 15.0985 8.24959 15C8.24959 14.9015 8.269 14.8039 8.30671 14.7128C8.34442 14.6218 8.3997 14.5391 8.46938 14.4694L10.9397 12L8.46938 9.53063C8.32865 9.38989 8.24959 9.19902 8.24959 9C8.24959 8.80098 8.32865 8.61011 8.46938 8.46937C8.61011 8.32864 8.80098 8.24958 9 8.24958C9.19903 8.24958 9.3899 8.32864 9.53063 8.46937L12 10.9397L14.4694 8.46937C14.5391 8.39969 14.6218 8.34442 14.7128 8.3067C14.8039 8.26899 14.9015 8.24958 15 8.24958C15.0986 8.24958 15.1961 8.26899 15.2872 8.3067C15.3782 8.34442 15.4609 8.39969 15.5306 8.46937C15.6003 8.53906 15.6556 8.62178 15.6933 8.71283C15.731 8.80387 15.7504 8.90145 15.7504 9C15.7504 9.09855 15.731 9.19613 15.6933 9.28717C15.6556 9.37822 15.6003 9.46094 15.5306 9.53063L13.0603 12L15.5306 14.4694Z"
                            fill="#FB5E56"
                          />
                        </g>
                      </svg>
                    )}
                    <Typography>Active Monitoring</Typography>
                  </Box>
                  <Box display={"flex"} gap={"8px"}>
                    {enrollmentRiskReport?.Status !== "Failed" &&
                    enrollmentRiskReport?.Status !== "Rejected" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g id="CheckCircle">
                          <path
                            id="Vector"
                            d="M16.2806 9.21937C16.3504 9.28903 16.4057 9.37175 16.4434 9.46279C16.4812 9.55384 16.5006 9.65144 16.5006 9.75C16.5006 9.84856 16.4812 9.94616 16.4434 10.0372C16.4057 10.1283 16.3504 10.211 16.2806 10.2806L11.0306 15.5306C10.961 15.6004 10.8783 15.6557 10.7872 15.6934C10.6962 15.7312 10.5986 15.7506 10.5 15.7506C10.4014 15.7506 10.3038 15.7312 10.2128 15.6934C10.1218 15.6557 10.039 15.6004 9.96938 15.5306L7.71938 13.2806C7.57865 13.1399 7.49959 12.949 7.49959 12.75C7.49959 12.551 7.57865 12.3601 7.71938 12.2194C7.86011 12.0786 8.05098 11.9996 8.25 11.9996C8.44903 11.9996 8.6399 12.0786 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.289 9.14964 15.3718 9.09432 15.4628 9.05658C15.5538 9.01884 15.6514 8.99941 15.75 8.99941C15.8486 8.99941 15.9462 9.01884 16.0372 9.05658C16.1283 9.09432 16.211 9.14964 16.2806 9.21937ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96451 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7661 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6497 3.75357 11.9909 3.59019 10.3905 3.90852C8.79017 4.22685 7.32016 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90853 10.3905C3.5902 11.9908 3.75358 13.6496 4.378 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77326 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z"
                            fill="#15B79F"
                          />
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g id="XCircle">
                          <path
                            id="Vector"
                            d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM15.5306 14.4694C15.6003 14.5391 15.6556 14.6218 15.6933 14.7128C15.731 14.8039 15.7504 14.9015 15.7504 15C15.7504 15.0985 15.731 15.1961 15.6933 15.2872C15.6556 15.3782 15.6003 15.4609 15.5306 15.5306C15.4609 15.6003 15.3782 15.6556 15.2872 15.6933C15.1961 15.731 15.0986 15.7504 15 15.7504C14.9015 15.7504 14.8039 15.731 14.7128 15.6933C14.6218 15.6556 14.5391 15.6003 14.4694 15.5306L12 13.0603L9.53063 15.5306C9.46095 15.6003 9.37822 15.6556 9.28718 15.6933C9.19613 15.731 9.09855 15.7504 9 15.7504C8.90146 15.7504 8.80388 15.731 8.71283 15.6933C8.62179 15.6556 8.53906 15.6003 8.46938 15.5306C8.3997 15.4609 8.34442 15.3782 8.30671 15.2872C8.269 15.1961 8.24959 15.0985 8.24959 15C8.24959 14.9015 8.269 14.8039 8.30671 14.7128C8.34442 14.6218 8.3997 14.5391 8.46938 14.4694L10.9397 12L8.46938 9.53063C8.32865 9.38989 8.24959 9.19902 8.24959 9C8.24959 8.80098 8.32865 8.61011 8.46938 8.46937C8.61011 8.32864 8.80098 8.24958 9 8.24958C9.19903 8.24958 9.3899 8.32864 9.53063 8.46937L12 10.9397L14.4694 8.46937C14.5391 8.39969 14.6218 8.34442 14.7128 8.3067C14.8039 8.26899 14.9015 8.24958 15 8.24958C15.0986 8.24958 15.1961 8.26899 15.2872 8.3067C15.3782 8.34442 15.4609 8.39969 15.5306 8.46937C15.6003 8.53906 15.6556 8.62178 15.6933 8.71283C15.731 8.80387 15.7504 8.90145 15.7504 9C15.7504 9.09855 15.731 9.19613 15.6933 9.28717C15.6556 9.37822 15.6003 9.46094 15.5306 9.53063L13.0603 12L15.5306 14.4694Z"
                            fill="#FB5E56"
                          />
                        </g>
                      </svg>
                    )}
                    <Typography>Billing Status</Typography>
                  </Box>
                </Box>
              </Box>
            </Card>
          </Box>
        </Box>
      </Container>
    </Box>

    <Modal centered show={show} onHide={handleClose}>
        <Modal.Header className="ms-auto border-0 color-primary">
          <FaRegWindowClose onClick={handleClose} />
        </Modal.Header>
        <Modal.Body className="px-5">
          <h1 style={{ color: "#0A579B", textAlign: "center" }}>Warning!</h1>
          <p style={{ textAlign: "center" }}>
           By resubmitting a new Tax Information Authorization Form (8821){" "}
           <strong>you could interrupt or delay current services. </strong>
          </p>
          <p style={{ textAlign: "center" }}>
           Please click “Yes, Submit a New Form” if you wish to proceed.
          </p>
          <div className="d-block mx-auto  text-center">
           <button
            style={{
             backgroundColor: "red",
             border: "2px solid red",
             width: "250px",
             fontWeight: 600,
            }}
            className="btn-continue mb-2"
            onClick={() => {
             navigate("/account-settings-new-report");
            }}
           >
            Yes, Submit a New Form
           </button>
           <span
            className="color-primary  text-decoration-underline d-block mx-auto fw-bold ff-Montserrat cursor-pointer"
            onClick={handleClose}
           >
              No, Cancel Change
            </span>
          </div>
        </Modal.Body>
      </Modal>
    </div>
    <Footer/>
    </>

  );
};

export default Overview;
